import api from '@/api'

// Estado inicial
const state = {
  warehouses: [],
  loading: false,
  error: null
}

// Getters
const getters = {
  allWarehouses: state => state.warehouses,
  loading: state => state.loading,
  error: state => state.error
}

// Acciones
const actions = {
  // Obtener todas las bodegas
  async fetchWarehouses({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await api.getWarehouses()
      commit('SET_WAREHOUSES', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Error al obtener bodegas')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  // Obtener una bodega específica
  async fetchWarehouse({ commit }, warehouseId) {
    commit('SET_LOADING', true)
    try {
      const response = await api.getWarehouse(warehouseId)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Error al obtener bodega')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  // Obtener zonas de una bodega
  async fetchWarehouseZones({ commit }, warehouseId) {
    commit('SET_LOADING', true)
    try {
      const response = await api.getWarehouseZones(warehouseId)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Error al obtener zonas de la bodega')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  // Crear una nueva bodega
  async createWarehouse({ commit, dispatch }, warehouseData) {
    commit('SET_LOADING', true)
    try {
      const response = await api.createWarehouse(warehouseData)
      dispatch('fetchWarehouses')
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Error al crear bodega')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  // Actualizar una bodega existente
  async updateWarehouse({ commit, dispatch }, warehouseData) {
    commit('SET_LOADING', true)
    try {
      const response = await api.updateWarehouse(warehouseData.id, warehouseData)
      dispatch('fetchWarehouses')
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Error al actualizar bodega')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  // Eliminar una bodega
  async deleteWarehouse({ commit, dispatch }, warehouseId) {
    commit('SET_LOADING', true)
    try {
      const response = await api.deleteWarehouse(warehouseId)
      dispatch('fetchWarehouses')
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message || 'Error al eliminar bodega')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

// Mutaciones
const mutations = {
  SET_WAREHOUSES(state, warehouses) {
    state.warehouses = warehouses
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
